module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_7.f560f1d9.jpg";